module.exports = __webpack_public_path__ + "static/img/6454_phase_function_Paper_Points.d136f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6454_phase_function_Paper_Points.png
// module id = IYW7
// module chunks = 0